import React, { FC } from 'react';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';

interface Props {
	onClose: () => void;
	onEnroll: () => void;
}

export const MFANotificationModal: FC<Props> = (props) => {
	const { onClose, onEnroll } = props;

	const enforcedMFAData = JSON.parse(localStorage.getItem('enforcedMFAData'));
	const skipAvailable = enforcedMFAData?.skipAvailable;
	const daysLeft = enforcedMFAData?.daysLeft;
	return (
		<div className="px-8">
			<div className="fs-6 mb-5">
				<span className="text-danger me-1">Flex</span>
				requires you to use 2-Step Verification to ensure better account security.
			</div>
			<div className="fw-bolder fs-6">
				<span className="me-1">You must enroll into 2-Step Verification</span>
				{
					Boolean(daysLeft) && <span className="me-1">in the next {daysLeft} days</span>
				}
				<span>or you will get locked out of your account.</span>
			</div>

			<div className="text-center mt-15">
				{skipAvailable && (
					<ButtonComponent
						buttonName="Skip"
						buttonType={BUTTON_TYPE.CANCELLED}
						additionalClass="btn-sm me-10"
						onButtonClick={onClose}
					/>
				)}
				<ButtonComponent
					buttonName="Enroll"
					additionalClass="btn-sm w-100px"
					onButtonClick={onEnroll}
				/>
			</div>

		</div>
	);
};
